import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/styles/table-style'
import axios from '../../../../config/axios'
import { useNavigate, useOutletContext } from 'react-router-dom'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import PricesDisplay from '../../../../components/PricesDisplay'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import { TypeMainOutlet } from '../..'
import { secondsToHHmm } from '../../../../utils/time'

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  padding-right: 10px;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

interface Service {
  id: number
  name: string
  code?: string
  category?: { id: number; name: string } | null
  type?: { id: number; name: string } | null
  sector?: { id: number; name: string; Area?: { id: number; name: string } | null } | null
  pricePerHour?: number
  prices?: Array<{
    id: number
    price: string
    unitOfMeasurement: {
      id: number
      name: string
    }
  }>
  deadlineInDays?: number
  executionTime?: number | null
  setupTime?: number | null
}

const StageServicesTable:React.FC = () => {
  const { refresh, setIsLoading } = useOutletContext<any>()
  const [services, setServices] = useState<Service[]>([])
  const [visibleCount, setVisibleCount] = useState<number>(50)
  const [ totalServices, setTotalServices ] = useState<number | undefined>(undefined)
  const navigate = useNavigate()
  const context = useOutletContext<TypeMainOutlet>();
// Garanta que você está pegando o valor da busca (string) e não a função
const search = typeof context?.search === 'string' ? context.search : "";
  

  useEffect(() => {
    const getServices = async () => {
      if (setIsLoading) setIsLoading(true)
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/services/service-stage`, {
          params: {
            limit: visibleCount,
            offset: 0,
            search: search
          }
        })
        if(response.data) setServices(response.data)
        if (setIsLoading) setIsLoading(false)
        try {
          const resp = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/services/service-stage/count`)
          if (resp && resp.data != null) {
            const value = typeof resp.data === 'number' ? resp.data : resp.data.totalItems ?? resp.data.total ?? undefined
            setTotalServices(value)
          }
        } catch (err) {
          setTotalServices(undefined)
        }
      } catch (error) {
        console.error(error)
        if (setIsLoading) setIsLoading(false)
      }
    }
    getServices()
  }, [visibleCount,search, refresh])

  const formatDeadline = (deadline?: number | null) => {
    if (!deadline) return 'N/A'
    return `${deadline} ${deadline === 1 ? 'dia útil' : 'dias úteis'}`
  }

  const formatTime = (value?: number | null) => {
    if (value == null) return 'N/A'
    const formatted = secondsToHHmm(value)
    return formatted ? formatted : 'N/A'
  }
  
  return (
    <TableWrapper>
      <GlobalTable>
      <thead>
        <HeaderLine>
          <Th>Serviço</Th>
          <Th>Área</Th>
          <Th>Setor</Th>
          <Th>Categoria</Th>
          <Th>Tipo</Th>
          <Th>Código</Th>
          <Th>Preço</Th>
          <Th>Prazo</Th>
          <Th>Tempo execução</Th>
          <Th>Tempo setup</Th>
          <Th></Th>
        </HeaderLine>
      </thead>
      <tbody>
        {services.map((service, index) => (
          <Tr key={index}>
            <Td>{service.name}</Td>
            <Td>{service.sector?.Area?.name || (service as any).Sector?.Area?.name || 'N/A'}</Td>
            <Td>{service.sector?.name || (service as any).Sector?.name || 'N/A'}</Td>
            <Td>{service.category?.name || (service as any).Category_Stage?.name || 'N/A'}</Td>
            <Td>{service.type?.name || (service as any).Type_Category_Stage?.name || 'N/A'}</Td>
            <Td>{service.code || 'N/A'}</Td>
            <Td>
              <PricesDisplay prices={service.prices || (service as any).StagePrice || []} maxWidth={200} />
            </Td>
            <Td>{formatDeadline(service.deadlineInDays)}</Td>
            <Td>{formatTime(service.executionTime)}</Td>
            <Td>{formatTime(service.setupTime)}</Td>
            <TdButtons>
              <img src={lookup} alt='looup-icon' onClick={() => navigate(`view/?id=${service.id}`)} />
            </TdButtons>
          </Tr>
        ))}
      </tbody>
    </GlobalTable>
    <LoadMoreButton
      onLoadMore={() => setVisibleCount(prev => prev + 50)}
      hasMore={typeof totalServices === 'number' ? services.length < totalServices : false}
      currentCount={services.length}
      totalCount={totalServices}
    />
    </TableWrapper>
    )
}

export default StageServicesTable
